<template>
  <div class="identifition-extra-staff" ref="identifitionLogExtraStaff">
    <div class="app-search-controls">
      <div class="wrap">
        <p>人脸编号</p>
        <el-input placeholder="请输入Person ID" v-model="search.id"></el-input>
      </div>
      <div class="wrap">
        <p>到访项目</p>
        <el-select v-model="search.project" placeholder="请选择到访项目" @change="positionChange" clearable>
          <el-option v-for="(value, index) in projectOptions" :key="index" :label="value.value" :value="value.value"></el-option>
        </el-select>
      </div>
      <div class="wrap">
        <p>抓拍位置</p>
        <el-select v-model="search.position" placeholder="请选择抓拍位置" clearable>
          <el-option v-for="(value, index) in positionOptions" :key="index" :label="value" :value="value"></el-option>
        </el-select>
      </div>
      <div class="wrap">
        <p>抓拍日期</p>
        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.period" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
      </div>
    </div>
    <div class="app-control app-table-control">
      <el-button type="primary" @click="searchParams">搜索</el-button>
      <el-button @click="resetParams">重置</el-button>
    </div>
    <el-table :data="datas" v-loading="loading">
      <el-table-column label="抓拍照片">
        <template slot-scope="{row}">
          <el-image :src="row.provide_attachment_data.attachment_access_url" :preview-src-list="[row.provide_attachment_data.attachment_access_url]"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="Person ID" prop="project_customer_open_id"></el-table-column>
      <el-table-column label="抓拍时间" prop="project_customer_recognition_log_recognition_at"></el-table-column>
      <el-table-column label="到访项目" prop="project_attr_name"></el-table-column>
      <el-table-column label="抓拍位置" prop="project_customer_recognition_log_location_name"></el-table-column>
      <el-table-column label="标签">
        <template slot-scope="{row}">
          <p>{{row.external_staff_tags.join('，')}}</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="245">
        <template slot-scope="{row}">
          <el-button type="text" @click="info(row.customer_id)">客户详情</el-button>
          <el-button type="text" @click="faceSearch(row.provide_attachment_data.attachment_id)">人脸搜索</el-button>
          <el-button type="text" @click="scan(row.provide_large_attachment_data.attachment_access_url)">查看大图</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
    <el-drawer :title="infoDialog.title" :visible.sync="infoDialog.show" center size="85%" append-to-body>
      <customer-info :id="infoDialog.id" v-if="infoDialog.show"></customer-info>
    </el-drawer>
    <el-drawer :title="faceDialog.title" :visible.sync="faceDialog.show" center size="85%" append-to-body>
      <search-by-picture :initVal="faceDialog.id" v-if="faceDialog.show"></search-by-picture>
    </el-drawer>
    <el-image-viewer :urlList="largeImage.value" :onClose="closeLargeImage" v-if="largeImage.show"></el-image-viewer>
  </div>
</template>

<script>
  import LogService from '@/io/log.js';
  import CustomerInfo from '@/views/CustomerInfo.vue';
  import SearchByPicture from '@/views/SearchByPicture.vue';
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer.vue';

  export default {
    name: 'IdentificationLogExtraStaff',
    data() {
      return {
        largeImage: {
          show: false,
          value: []
        },
        datas: [],
        loading: false,
        search: {
          id: '',
          position: '',
          project: '',
          period: [],
        },
        positionOptions: [],
        projectOptions: [],
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        },
        infoDialog: {
          title: '客户详情',
          show: false,
          id: null
        },
        faceDialog: {
          title: '人脸搜索',
          show: false,
          id: null
        }
      }
    },
    components: {
      CustomerInfo,
      SearchByPicture,
      ElImageViewer
    },
    mounted () {
      this.$nextTick(() => {
        if (this.$refs.identifitionLogExtraStaff) {
          this.initPage();
        }
      });
    },
    methods: {
      positionChange(value) {
        if (value) {
          this.projectOptions.forEach((val, index) => {
            if (val.value === value) {
              this.positionOptions = val.position;
            }
          });
        } else {
          this.positionOptions = [];
        }
        this.search.position = '';
      },
      initPage() {
        this.initParam().then(() => {
          this.initDatas();
        }).catch(() => {});
      },
      initParam() {
        return LogService.customerParamInfo().then(res => {
          this.projectOptions = res.data.project_customer_recognition_log_search_structure.map(val => {
            return {
              value: val.value,
              position: val.child.project_customer_recognition_log_location_name
            }
          });
        }).catch(() => {});
      },
      initDatas() {
        this.loading = true;
        LogService.extraStaffLog(
          this.search.id,
          this.search.project,
          this.search.position,
          this.search.period ? this.search.period[0] : '',
          this.search.period ? this.search.period[1] : '',
          this.page.currentPage
        ).then(res => {
          this.datas = res.data.data;
          this.page.pageSize = res.data.per_page;
          this.page.total = res.data.total;
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.id = '';
        this.search.project = '';
        this.search.position = '';
        this.search.period = [];
        this.searchParams();
      },
      info(id) {
        this.infoDialog.show = true;
        this.infoDialog.id = id;
      },
      faceSearch(id) {
        this.faceDialog.show = true;
        this.faceDialog.id = id;
      },
      scan(src) {
        this.setWaterMark('本图片仅用于视频监控', `${this.$store.state.userInfo.account_attr_data.account_attr_name}`);
        this.largeImage.value = [src];
        this.largeImage.show = true;
      },
      closeLargeImage() {
        this.removeWatermark();
        this.largeImage.value = [];
        this.largeImage.show = false;
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  /deep/ .el-drawer {
    .el-drawer__body {
      background-color: @color-1;
      padding: @distance;
    }
  }
</style>